<script setup>
import IconsComp from "./IconsComp.vue";

defineProps({
  titulo: String,
  conteudo: String,
  collapseOpen: {
    type: Boolean,
    default: false,
  },
  tituloClass: String,
});

defineEmits(["update:collapseOpen"]);
</script>
<template>
  <div class="comp-collapse">
    <!-- Header Collapse -->
    <div
      class="header"
      @click="$emit('update:collapseOpen', (collapseOpen = !collapseOpen))"
    >
      <span
        :class="{
          'rotate-90': collapseOpen,
          '-translate-y-0.0': !collapseOpen,
        }"
      >
        <IconsComp
          :icon="collapseOpen ? 'minus-square' : 'add-square'"
          :class="{
            '-rotate-90': collapseOpen,
            '-translate-y-0.0': !collapseOpen,
          }"
        />
      </span>
      <div class="title" :class="tituloClass">
        {{ titulo }}
      </div>
    </div>
    <!-- Body Collpase -->
    <div
      class="body"
      :class="{
        'h-0 opacity-0': !collapseOpen,
        'h-auto opacity-100': collapseOpen,
      }"
    >
      <div class="overflow-hidden" v-show="collapseOpen">
        <slot> </slot>
      </div>
    </div>
  </div>
</template>
